"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosRefreshResultSchema = exports.APosDismissAlertInputSchema = exports.APosApproveAlertInputSchema = exports.APosUpdateSettingsInputSchema = exports.APosListAlertsResponseSchema = void 0;
// inventory-alerts-api.schema.ts
const zod_1 = require("zod");
const inventory_alert_schema_1 = require("../../entities/agenticpos/inventory-alert.schema");
exports.APosListAlertsResponseSchema = zod_1.z.object({
    items: zod_1.z.array(inventory_alert_schema_1.APosInventoryAlertSchema),
    count: zod_1.z.number().int().nonnegative(),
    lastKey: zod_1.z.string().optional(),
});
exports.APosUpdateSettingsInputSchema = inventory_alert_schema_1.APosInventoryAlertSettingsSchema.partial().extend({
    locationId: zod_1.z.string().optional(), // omit/`DEFAULT` = tenant default; else per-location override
});
exports.APosApproveAlertInputSchema = zod_1.z.object({
    action: zod_1.z.enum(['transfer', 'reorder']),
});
exports.APosDismissAlertInputSchema = zod_1.z.object({
    reason: zod_1.z.string().max(500).default(''),
});
exports.APosRefreshResultSchema = zod_1.z.object({
    status: zod_1.z.enum(['ran', 'skipped_insufficient_credits', 'rate_limited']),
    alertsWritten: zod_1.z.number().int().nonnegative().default(0),
});
//# sourceMappingURL=inventory-alerts-api.schema.js.map